<template>
  <div class="checkbox-wrapper">
    <div class="checkbox-inner">
      <label class="checkbox">
        <input
          type="checkbox"
          class="checkbox__input"
          tabindex="0"
          @keydown.space="onClick"
        >
        <div
          :class="[
            'checkbox__custom',
            { 'checkbox__custom_checked' : checked, 'disabledColor': validate }
          ]"
          @click="onClick"
        >
          <transition name="drop">
            <Checkmark
              v-if="checked"
              class="checkbox__custom-checkmark"
            />
          </transition>
        </div>
      </label>

      <div class="checkbox__text">
        <slot />
      </div>
    </div>

    <transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="checkbox__error-msg"
      >
        {{ errorMsg }}
      </span>
    </transition>
  </div>
</template>

<script>
  import Checkmark from '@/assets/img/icons/checkmark.svg?inline'

  export default {
    name: 'BaseCheckbox',
    components: {
      Checkmark
    },
    props: {
      customHandler: {
        type: Function
      },
      validate: {
        type: Boolean,
        default: false
      },
      value: {
        type: Boolean,
        default: false
      },
      errorMsg: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        checked: this.value,
        error: null
      }
    },
    watch: {
      value: {
        handler (v) {
          this.checked = v
        },
        immediate: true
      },
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },
    methods: {
      onClick () {
        if (!this.validate || this.checked) {
          this.error = false
          this.checked = !this.checked
          this.$emit('input', this.checked)
        } else if (this.customHandler) {
          this.customHandler()
        }
      }
    }
  }
</script>

<style lang="scss">
  $padding-for-error: 28px;

  .checkbox {
    display: inline-block;
    flex-shrink: 0;
    width: 24px;
    height: 24px;

    @include hover {
      .checkbox__custom {
        border-color: $c-black;
      }
    }

    &-inner {
      display: flex;
      align-items: center;
    }

    &-wrapper {
      position: relative;
    }

    &__custom {
      width: 100%;
      height: 100%;
      cursor: pointer;
      border: 1px solid $c-gray-medium;
      transition: 0.3s;

      &.disabledColor {
        border-color: $c-gray-medium70 !important;
      }

      &_checked {
        border-color: $c-black;
      }

      &-checkmark {
        width: 12px;
        height: 9px;
        margin-left: 5px;
      }
    }

    &__input {
      position: absolute;
      left: -9999999px;
      width: 0;
      height: 0;
      opacity: 0;
    }

    &__text {
      margin-left: 15px;
      font-family: "FavoritC", Arial, Helvetica, sans-serif;

      a {
        font-size: 17px;
        line-height: 24px;

        @include mobile {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }

    &__error-msg {
      position: absolute;
      top: 77%;
      left: 0;
      font-size: 12px;
      color: $c-active-light;
    }
  }
</style>
